import { ReturnReasonSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/return-reasons";
import { VariantExchangeRecommendationsSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/variant-exchange-recommendations";
import { ReturnProductSchema } from "@redotech/redo-model/draft-return/draft-return-items";
import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getVariantExchangeRecommendations = {
  name: "getVariantExchangeRecommendations" as const,
  input: z.object({
    draftReturnId: z.string(),
    returnProduct: ReturnProductSchema,
    returnReasons: z.array(ReturnReasonSchema),
    returnType: createEnum(ReturnTypeEnum).optional(),
    locale: z.string().optional(),
  }),
  output: VariantExchangeRecommendationsSchema.optional(),
};
